export interface WireValidationSummary {
  orderId: string;
  orderStatus: string;
  statusDate: string;
  message?: string;
  validationStatus: string;
}
export enum WireType {
  PERSONAL = 'Personal',
  BUSINESS = 'Business',
  MORTGAGE_PAYOFF = 'MortgagePayoff',
}

export interface WireValidationListResult {
  fileId: string;
  fileNumber: string;
  underwriterCode: string;
  underwriterName: string;
  wireType: string;
  payee: string;
  bankName?: string;
  wireAmount: number;
  wireValidationSummary: WireValidationSummary;
  requestedByName: string;
  requestedBy: string;
  requestedDate: string;
}

export interface WireValidationRow {
  fileId: string;
  fileNumber: string;
  payee: string;
  wireType: string;
  wireAmount: number;
  validationStatus: string;
  statusMessage?: string;
  orderId: string;
  requestedByName: string;
  requestedDate: string;
  payeeOrBankName: string;
}

export interface WireValidationSubmitRequest {
  firmId: number;
  fileNumber: string;
  underwriter: string;
  wireType: string;
  bankName: string;
  routingNumber: string;
  accountNumber: string;
  wireAmount: number;
  businessName?: string;
  firstName?: string;
  lastName?: string;
  address?: {
    address1: string;
    address2?: string;
    city: string;
    stateOrProvince: string;
    postalCode: string;
  };
  phoneNumber?: string;
  email?: string;
}

export interface WireValidationResultDetail {
  validationStatus: string;
  message: string;
}

export interface WireValidationDetail {
  fileId: string;
  transactionId: string;
  transactionStatus: string;
  result: WireValidationResultDetail;
  requestedDate: string;
}

export interface WireValidationSubmitResponse {
  wireType: string;
  bankName: string;
  routingNumber: string;
  accountNumber: string;
  wireAmount: number;
  underwriter: string;
  fileNumber: string;
  underwriterName: string;
  payee: string;
  businessName?: string;
  firstName?: string;
  lastName?: string;
  address1?: string;
  address2?: string;
  city?: string;
  stateCode?: string;
  postalCode?: string;
  phoneNumber?: string;
  email?: string;
  wireValidation: WireValidationDetail;
}
